import { isNotPresent, isPresent } from "neetocist";
import { Dropdown } from "neetoui";

const LinkSection = ({ links }) => {
  const { MenuItem } = Dropdown;
  if (isNotPresent(links)) return null;

  return (
    <>
      {links.map(({ label, icon: Icon, changesCount, ...otherProps }, idx) => (
        <MenuItem.Button
          className="neeto-molecules-menu-sublist__item-btn"
          data-testid="floating-action-menu-link-section"
          key={idx}
          prefix={Icon && <Icon size={18} />}
          style="text"
          {...otherProps}
        >
          {label}
          {isPresent(changesCount) && (
            <span
              className="neeto-molecules-menu-list__item-btn-count"
              data-testid="help-section-menu-changes-count"
            >
              {changesCount}
            </span>
          )}
        </MenuItem.Button>
      ))}
    </>
  );
};

export default LinkSection;
